import { type SugarProviderPhoto } from '@app/types'
import { ActionIcon, AspectRatio, Badge, Box, Group, Image, Tooltip } from '@mantine/core'
import { IconRefresh, IconX } from '@tabler/icons-react'
import { type FC } from 'react'

import { PHOTO_STATUS_DISPLAY } from './statusDisplay'
import { photoImageUrl } from './photoImageUrl'

export interface PhotoTileProps {
  disabled?: boolean
  onRemove: () => void
  onReplace: () => void
  photo: SugarProviderPhoto
}

export const PhotoTile: FC<PhotoTileProps> = ({ disabled = false, onRemove, onReplace, photo }) => {
  const display = PHOTO_STATUS_DISPLAY[photo.status]

  return (
    <Box pos='relative' style={{ borderRadius: 8, overflow: 'hidden' }}>
      <AspectRatio ratio={1}>
        <Image
          alt={photo.filename}
          src={photoImageUrl(photo)}
          withPlaceholder
        />
      </AspectRatio>
      <Badge
        color={display.color}
        pos='absolute'
        style={{ left: 8, top: 8 }}
        variant='filled'
      >
        {display.label}
      </Badge>
      <Group
        pos='absolute'
        spacing={4}
        style={{ right: 8, top: 8 }}
      >
        <Tooltip label='Replace photo' withinPortal>
          <ActionIcon
            aria-label='Replace photo'
            color='dark'
            disabled={disabled}
            onClick={onReplace}
            size='lg'
            variant='filled'
          >
            <IconRefresh size={18} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label='Remove photo' withinPortal>
          <ActionIcon
            aria-label='Remove photo'
            color='red'
            disabled={disabled}
            onClick={onRemove}
            size='lg'
            variant='filled'
          >
            <IconX size={18} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Box>
  )
}
